import { render, staticRenderFns } from "./StructureChamber.vue?vue&type=template&id=490c4681&scoped=true&"
import script from "./StructureChamber.vue?vue&type=script&lang=js&"
export * from "./StructureChamber.vue?vue&type=script&lang=js&"
import style0 from "./StructureChamber.vue?vue&type=style&index=0&id=490c4681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c4681",
  null
  
)

export default component.exports